import Header from "./Components/Header";
import FooterWithSignup from "./Components/FooterWithSignup";
import '../styles/CookClubTerms.css'

function CookClubTerms() {
    return (
        <div className="cook-club-terms-page">
            <Header />

            <div className="cook-club-terms-container">
                <h1>Denny Cook Club Terms &amp; Conditions</h1>

                <p>
                    These Terms and Conditions ("Terms") govern participation in the
                    Denny Cook Club ("Cook Club"). By participating in the Cook Club,
                    all participants agree to be bound by these Terms.
                </p>

                <h2>1. Promoter</h2>

                <p>
                    <strong>1.1</strong> The Cook Club is organised and administered by
                    Denny ("the Promoter", "Denny", "we", "our", or "us").
                </p>

                <p>
                    <strong>1.2</strong> The Cook Club is in no way sponsored,
                    endorsed, administered by, or associated with Instagram,
                    Facebook, TikTok, WhatsApp, YouTube, or any other social media
                    platform used in connection with the Cook Club.
                </p>

                <p>
                    <strong>1.3</strong> The Promoter reserves the right to appoint an
                    authorised agency or partner to administer portions of the Cook
                    Club on its behalf.
                </p>

                <h2>2. Cook Club Period</h2>

                <p>
                    <strong>2.1</strong> The Cook Club will run during dates
                    communicated by the Promoter across its digital and social media
                    platforms.
                </p>

                <p>
                    <strong>2.2</strong> The Promoter reserves the right to extend,
                    shorten, suspend, amend, or terminate the Cook Club or any
                    campaign period at its sole discretion without prior notice.
                </p>

                <p>
                    <strong>2.3</strong> No late entries or submissions will be
                    accepted after communicated deadlines.
                </p>

                <h2>3. Eligibility</h2>

                <p>
                    <strong>3.1</strong> Participation is open to legal residents of
                    South Africa aged 18 years or older.
                </p>

                <p>
                    <strong>3.2</strong> Employees, directors, agents, consultants,
                    suppliers, affiliates, advertising agencies, and immediate family
                    members of the Promoter are not eligible to participate.
                </p>

                <p>
                    <strong>3.3</strong> Participants must:
                </p>

                <ul>
                    <li>Have an active and valid social media account.</li>
                    <li>Be reachable via the submitted contact details.</li>
                    <li>Have access to WhatsApp for submission purposes.</li>
                    <li>
                        Be willing and able to create original recipe content
                        featuring Denny products.
                    </li>
                </ul>

                <p>
                    <strong>3.4</strong> The Promoter reserves the right to request
                    proof of identity, age, and residence at any time.
                </p>

                <h2>4. How to Enter</h2>

                <p>
                    <strong>4.1</strong> Participants must complete the official Denny
                    Cook Club registration form.
                </p>

                <p>
                    <strong>4.2</strong> Participants may be required to provide:
                </p>

                <ul>
                    <li>Full name</li>
                    <li>Contact number</li>
                    <li>Email address</li>
                    <li>Province or city</li>
                    <li>Social media handles</li>
                    <li>Audience or follower information</li>
                    <li>Any additional information reasonably requested by the Promoter</li>
                </ul>

                <p>
                    <strong>4.3</strong> Submission of an entry form does not
                    guarantee selection.
                </p>

                <p>
                    <strong>4.4</strong> Selected participants may be shortlisted
                    based on:
                </p>

                <ul>
                    <li>Content quality and creativity</li>
                    <li>Audience engagement</li>
                    <li>Brand suitability</li>
                    <li>Social media presence</li>
                    <li>Geographic relevance</li>
                    <li>Overall campaign fit</li>
                </ul>

                <p>
                    <strong>4.5</strong> Shortlisted participants may:
                </p>

                <ul>
                    <li>Receive a confirmation call.</li>
                    <li>Be required to sign participation agreements.</li>
                    <li>Receive a Denny product hamper or campaign pack.</li>
                </ul>

                <p>
                    <strong>4.6</strong> Participants will receive a campaign brief
                    outlining:
                </p>

                <ul>
                    <li>Product requirements</li>
                    <li>Submission deadlines</li>
                    <li>Content guidelines</li>
                    <li>Delivery requirements</li>
                </ul>

                <h2>5. Content Requirements</h2>

                <p><strong>5.1</strong> All submitted content must:</p>

                <ul>
                    <li>Be original and created by the participant.</li>
                    <li>Feature Denny products prominently and positively.</li>
                    <li>Be suitable for public viewing.</li>
                    <li>Comply with applicable laws and platform guidelines.</li>
                </ul>

                <p><strong>5.2</strong> Submitted content may not contain:</p>

                <ul>
                    <li>Offensive, defamatory, hateful, discriminatory, unlawful, or inappropriate material.</li>
                    <li>Unauthorised music, logos, trademarks, or copyrighted material.</li>
                    <li>Competing food or cooking brands.</li>
                    <li>Misleading or deceptive claims.</li>
                </ul>

                <p>
                    <strong>5.3</strong> Participants may not submit AI-generated or
                    copied content without proper authorisation.
                </p>

                <p>
                    <strong>5.4</strong> The Promoter reserves the right to reject,
                    remove, edit, or disqualify any content deemed inappropriate or
                    inconsistent with the objectives of the Cook Club.
                </p>

                <h2>6. Content Submission</h2>

                <p><strong>6.1</strong> Content must be submitted via the official WhatsApp submission line communicated to selected participants.</p>

                <p><strong>6.2</strong> Participants must ensure submitted files are accessible, downloadable, and in an acceptable format.</p>

                <p><strong>6.3</strong> Failure to submit qualifying content within the stipulated deadline may result in disqualification.</p>

                <p><strong>6.4</strong> Submission of content does not guarantee selection, publication, or payment.</p>

                <h2>7. Intellectual Property &amp; Content Usage Rights</h2>

                <p><strong>7.1</strong> By submitting any content, participants:</p>

                <ul>
                    <li>Confirm that they are the original creator and owner of the content.</li>
                    <li>
                        Grant the Promoter a royalty-free, non-exclusive licence to
                        use, edit, adapt, publish, distribute, repost, resize,
                        promote, advertise, and display the content across Denny
                        marketing channels for promotional and campaign-related
                        purposes.
                    </li>
                </ul>

                <p><strong>7.2</strong> The Promoter may:</p>

                <ul>
                    <li>Use the content on social media, websites, digital advertising, paid media, presentations, and promotional campaigns.</li>
                    <li>Edit or adapt content for formatting, branding, resizing, subtitles, or platform optimisation.</li>
                    <li>Use participant names, social media handles, likenesses, and voices in connection with the Denny Cook Club.</li>
                </ul>

                <p><strong>7.3</strong> Participants acknowledge that:</p>

                <ul>
                    <li>The Promoter is under no obligation to publish submitted content.</li>
                    <li>Only officially selected content qualifies for payment.</li>
                    <li>No additional royalties, residuals, or compensation shall be payable beyond the agreed creator payment.</li>
                </ul>

                <p>
                    <strong>7.4</strong> The Promoter may continue using approved
                    content for the duration specified in the participant agreement or
                    campaign terms.
                </p>

                <h2>8. Third-Party Appearances &amp; Releases</h2>

                <p><strong>8.1</strong> Participants warrant that all individuals appearing in submitted content have granted full permission and consent for their image, likeness, voice, and appearance to be used by the Promoter.</p>

                <p><strong>8.2</strong> Participants are solely responsible for obtaining any required permissions, releases, or waivers from individuals appearing in submitted content.</p>

                <p><strong>8.3</strong> Where minors appear in submitted content, participants confirm that parental or legal guardian consent has been obtained.</p>

                <p><strong>8.4</strong> Participants indemnify the Promoter against any claims arising from unauthorised appearances or third-party rights issues.</p>

                <h2>9. Winner Selection &amp; Payment</h2>

                <p><strong>9.1</strong> Selected content creators may receive a payment of R2,500 per approved video submission.</p>

                <p><strong>9.2</strong> Payment will only be made for content officially approved and selected by the Promoter.</p>

                <p><strong>9.3</strong> Submission of content alone does not guarantee payment.</p>

                <p><strong>9.4</strong> Payments are non-transferable, not exchangeable, and subject to verification.</p>

                <p><strong>9.5</strong> Winners must provide accurate banking and payment information.</p>

                <p><strong>9.6</strong> The Promoter shall not be liable for payment delays caused by incorrect information supplied by participants.</p>

                <h2>10. Participant Conduct</h2>

                <p><strong>10.1</strong> Participants may not:</p>

                <ul>
                    <li>Use bots, fake followers, or fraudulent engagement.</li>
                    <li>Misrepresent themselves.</li>
                    <li>Damage or attempt to damage the reputation of Denny or the Cook Club.</li>
                </ul>

                <p><strong>10.2</strong> The Promoter reserves the right to disqualify any participant suspected of fraudulent conduct, misconduct, breach of these Terms, or behaviour harmful to the Denny brand.</p>

                <p><strong>10.3</strong> Participants who receive campaign products but fail to submit qualifying content may be excluded from future campaigns.</p>

                <h2>11. Privacy &amp; POPIA Compliance</h2>

                <p><strong>11.1</strong> By participating in the Cook Club, participants consent to the collection, processing, and storage of their personal information for purposes relating to:</p>

                <ul>
                    <li>Cook Club administration</li>
                    <li>Participant vetting</li>
                    <li>Prize fulfilment</li>
                    <li>Marketing and promotional communications</li>
                    <li>Publication of selected content and winner announcements</li>
                </ul>

                <p><strong>11.2</strong> Personal information will be processed in accordance with the Protection of Personal Information Act, 2013 ("POPIA").</p>

                <p><strong>11.3</strong> Participants may request access to, correction of, or deletion of their personal information by contacting the Promoter.</p>

                <p><strong>11.4</strong> The Promoter undertakes to take reasonable steps to protect personal information from unauthorised access, misuse, or disclosure.</p>

                <h2>12. Limitation of Liability</h2>

                <p><strong>12.1</strong> To the fullest extent permitted by law, the Promoter shall not be liable for:</p>

                <ul>
                    <li>Technical failures, network issues, or submission errors.</li>
                    <li>Lost, delayed, incomplete, corrupted, or inaccessible submissions.</li>
                    <li>Any loss, injury, damage, or claim arising from participation in the Cook Club.</li>
                    <li>Any interruption, cancellation, or amendment of the Cook Club.</li>
                </ul>

                <p><strong>12.2</strong> Participants participate entirely at their own risk.</p>

                <h2>13. General</h2>

                <p><strong>13.1</strong> The Promoter reserves the right to amend these Terms at any time without prior notice.</p>

                <p><strong>13.2</strong> Any violation of these Terms may result in disqualification.</p>

                <p><strong>13.3</strong> If any provision of these Terms is found unenforceable, the remaining provisions shall remain valid and enforceable.</p>

                <p><strong>13.4</strong> These Terms shall be governed by the laws of South Africa.</p>

                <p><strong>13.5</strong> Any disputes arising from the Cook Club shall be subject to the exclusive jurisdiction of the courts of South Africa.</p>

                <p><strong>13.6</strong> By participating in the Cook Club, participants confirm that they have read, understood, and agreed to these Terms and Conditions in full.</p>
            </div>

            <FooterWithSignup />
        </div>
    );
}

export default CookClubTerms;
